import script from "./addCatView.vue?vue&type=script&setup=true&lang=ts"
export * from "./addCatView.vue?vue&type=script&setup=true&lang=ts"

import "./addCatView.vue?vue&type=style&index=0&id=5cc5eac5&lang=scss&scoped=true"

import exportComponent from "/home/pilki/freelaix/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cc5eac5"]])

export default __exports__